<template>
  <div class="enroll-layout">
    <div class="bg-orb orb-a"></div>
    <div class="bg-orb orb-b"></div>
    <header class="enroll-header">
      <div class="title-wrap">
        <h1>上实东滩高中自主招生系统</h1>
        <p>欢迎填报自主招生信息</p>
      </div>
      <div class="header-actions">
        <el-tag type="info">{{ studentName || '学生用户' }}</el-tag>
        <el-button type="primary" plain @click="logout">退出登录</el-button>
      </div>
    </header>

    <el-container class="enroll-main">
      <el-aside width="220px" class="enroll-aside">
        <el-menu :default-active="$route.path" router class="side-menu">
          <el-menu-item index="/enroll/form">填写/修改信息</el-menu-item>
          <el-menu-item index="/enroll/status">审核进度</el-menu-item>
        </el-menu>
      </el-aside>
      <el-main class="enroll-content-main">
        <div class="content-shell">
          <router-view />
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { enrollmentStudentApi } from '@/api'
import { clearEnrollAuth, getEnrollUser, setEnrollUser } from '@/utils/auth'

const router = useRouter()
const studentName = ref('')

const loadProfile = async () => {
  const local = getEnrollUser()
  if (local?.name) {
    studentName.value = local.name
  }
  const profile = await enrollmentStudentApi.me()
  studentName.value = profile.name
  setEnrollUser({
    id: profile.id,
    name: profile.name,
    id_card: profile.id_card,
    phone: profile.phone,
    review_status: profile.review_status,
    application_submitted: profile.application_submitted
  })
}

const logout = async () => {
  try {
    await enrollmentStudentApi.logout()
  } catch (error) {
    // 忽略服务端退出异常，保证前端会话被清理
  }
  clearEnrollAuth()
  router.replace('/enroll/login')
}

onMounted(() => {
  loadProfile()
})
</script>

<style scoped>
.enroll-layout {
  min-height: 100vh;
  background:
    radial-gradient(circle at 15% 20%, rgba(14, 165, 233, 0.12), transparent 28%),
    radial-gradient(circle at 82% 14%, rgba(59, 130, 246, 0.16), transparent 25%),
    linear-gradient(165deg, #f8fafc 0%, #eef7ff 48%, #e0f2fe 100%);
  position: relative;
  overflow: hidden;
}

.bg-orb {
  position: absolute;
  border-radius: 999px;
  filter: blur(1px);
  pointer-events: none;
}

.orb-a {
  width: 220px;
  height: 220px;
  background: rgba(59, 130, 246, 0.16);
  top: -80px;
  left: -40px;
}

.orb-b {
  width: 300px;
  height: 300px;
  background: rgba(14, 165, 233, 0.1);
  right: -120px;
  bottom: -140px;
}

.enroll-header {
  min-height: 86px;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.78);
  border-bottom: 1px solid rgba(191, 219, 254, 0.7);
  backdrop-filter: blur(10px);
  position: sticky;
  top: 0;
  z-index: 10;
}

.title-wrap h1 {
  font-size: 23px;
  letter-spacing: 0.4px;
  color: #0b3a73;
}

.title-wrap p {
  color: #64748b;
  margin-top: 4px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.enroll-main {
  min-height: calc(100vh - 86px);
  position: relative;
  z-index: 1;
}

.enroll-aside {
  background: rgba(255, 255, 255, 0.75);
  border-right: 1px solid rgba(226, 232, 240, 0.8);
  backdrop-filter: blur(10px);
  padding: 16px 10px;
}

.side-menu {
  border: none;
  border-radius: 14px;
  overflow: hidden;
}

:deep(.side-menu .el-menu-item) {
  border-radius: 10px;
  margin: 4px 8px;
}

:deep(.side-menu .el-menu-item.is-active) {
  background: linear-gradient(90deg, rgba(59, 130, 246, 0.15), rgba(14, 165, 233, 0.06));
  color: #1d4ed8;
}

.enroll-content-main {
  padding: 20px;
}

.content-shell {
  max-width: 1280px;
  margin: 0 auto;
}

@media (max-width: 900px) {
  .enroll-header {
    padding: 14px 16px;
    min-height: auto;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .title-wrap h1 {
    font-size: 20px;
  }

  .enroll-main {
    display: block;
  }

  .enroll-aside {
    width: 100% !important;
    border-right: none;
    border-bottom: 1px solid rgba(226, 232, 240, 0.8);
    padding: 10px 8px 6px;
  }

  :deep(.side-menu) {
    display: flex;
  }

  :deep(.side-menu .el-menu-item) {
    flex: 1;
    justify-content: center;
  }

  .enroll-content-main {
    padding: 12px;
  }
}
</style>
